export enum enumMarineInsuranceStatusType {
  INSURED,
  EXTERNALLY_INSURED,
  NOT_INSURED,
}
